// sidenav.service.ts
import { Injectable } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';

@Injectable({ providedIn: 'root' })
export class SidenavService {
  private sidenav: MatSidenav | null = null;

  public setSidenav(sidenav: MatSidenav) {
    this.sidenav = sidenav;
  }

  public toggle(): void {
    this.sidenav?.toggle();

  }

  public open(): void {
    this.sidenav?.open();

    //document.getElementById('snav')?.show();
  }

  public close(): void {
    this.sidenav?.close();
  }
}
